import actions from "./actions";

const {
  EXCHANGE_DASHBOARD_DATA_BEGIN,
  EXCHANGE_DASHBOARD_DATA_SUCCESS,
  EXCHANGE_DASHBOARD_DATA_ERR,

  APPROVAL_LIST_BEGIN,
  APPROVAL_LIST_SUCCESS,
  APPROVAL_LIST_ERR,
  APPROVAL_LIST_RESET,

  APPROVAL_DETAILS_BEGIN,
  APPROVAL_DETAILS_SUCCESS,
  APPROVAL_DETAILS_ERR,
  APPROVAL_DETAILS_RESET,

  UPDATE_APPROVAL_STATUS_BEGIN,
  UPDATE_APPROVAL_STATUS_SUCCESS,
  UPDATE_APPROVAL_STATUS_ERR,
  UPDATE_APPROVAL_STATUS_RESET,
} = actions;

const initialState = { data: null, loading: false, error: null };

export const exchangeDashboardReducers = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case EXCHANGE_DASHBOARD_DATA_BEGIN:
      return { ...initialState, loading: true };

    case EXCHANGE_DASHBOARD_DATA_SUCCESS:
      return { ...initialState, data, loading: false };

    case EXCHANGE_DASHBOARD_DATA_ERR:
      return { ...initialState, error: err, loading: false };

    default:
      return state;
  }
};

export const approvalListReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case APPROVAL_LIST_BEGIN:
      return { ...initialState, loading: true };

    case APPROVAL_LIST_SUCCESS:
      return { ...initialState, data, loading: false };

    case APPROVAL_LIST_ERR:
      return { ...initialState, error: err, loading: false };

    case APPROVAL_LIST_RESET:
      return initialState;

    default:
      return state;
  }
};

export const approvalDetailsReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case APPROVAL_DETAILS_BEGIN:
      return { ...initialState, loading: true };

    case APPROVAL_DETAILS_SUCCESS:
      return { ...initialState, data, loading: false };

    case APPROVAL_DETAILS_ERR:
      return { ...initialState, error: err, loading: false };

    case APPROVAL_DETAILS_RESET:
      return initialState;

    default:
      return state;
  }
};

export const updateApprovalStatusReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case UPDATE_APPROVAL_STATUS_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case UPDATE_APPROVAL_STATUS_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case UPDATE_APPROVAL_STATUS_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    case UPDATE_APPROVAL_STATUS_RESET:
      return initialState;

    default:
      return state;
  }
};
